import { buildActionstepOutcomeNote } from "./outlookAppearanceFormat.js";

const REQUEST_LABELS = {
  action_item: "Action item",
  close_file: "Close file",
  document: "Generate document",
};

function clean(value) {
  return `${value || ""}`.trim();
}

export function buildLacwPortalRequest({
  requestKind,
  matter,
  appearance,
  details,
  documentType,
  priority = "Normal",
  senderEmail = "",
}) {
  const requestLabel = REQUEST_LABELS[requestKind];
  if (!requestLabel) throw new Error("Select a valid LACW portal request.");

  const clientName = clean(matter?.client?.fullName) || clean(appearance?.clientName) || "Client";
  const matterId =
    clean(matter?.client?.fileNumber) ||
    clean(matter?.externalId) ||
    clean(appearance?.fileNumber);
  const requestDetails = clean(details);
  const selectedDocumentType = clean(documentType);

  if (!matterId) throw new Error("The selected matter needs a file reference.");
  if (!requestDetails) throw new Error(`Enter details for the ${requestLabel.toLowerCase()} request.`);
  if (requestKind === "document" && !selectedDocumentType) {
    throw new Error("Select the document to generate.");
  }

  const subjectDetail =
    requestKind === "document" ? `${selectedDocumentType} - ${clientName}` : `${requestLabel} - ${clientName}`;
  const fundingLines = [
    appearance?.fundingType ? `Funding type: ${clean(appearance.fundingType)}` : "",
    appearance?.fundingType === "Legal Aid" && appearance?.grantOfAidNumber
      ? `Grant of aid number: ${clean(appearance.grantOfAidNumber)}`
      : "",
  ].filter(Boolean);

  return {
    clientId: "lacw",
    matterId,
    priority,
    subject: `[Follow up] ${subjectDetail}`,
    body: [
      `LACW portal request: ${requestLabel}`,
      requestKind === "document" ? `Document type: ${selectedDocumentType}` : "",
      `Client: ${clientName}`,
      `Matter: ${matterId}`,
      ...fundingLines,
      "",
      buildActionstepOutcomeNote(appearance),
      "",
      `Request details: ${requestDetails}`,
    ]
      .filter((line, index, lines) => line !== "" || lines[index - 1] !== "")
      .join("\n")
      .trim(),
    comments: requestDetails,
    attachments: [],
    senderEmail: clean(senderEmail),
  };
}

export function saveDemoPortalRequest(payload, storage = globalThis.sessionStorage) {
  const record = {
    id: `demo-portal-${Date.now()}`,
    ...payload,
    simulated: true,
    createdAt: new Date().toISOString(),
  };

  storage?.setItem?.("cls-outlook-demo-portal-request", JSON.stringify(record));
  return record;
}
